import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";

// Rimac-inspired color-shift transition band. The horizontal light streak crosses the section.
// Background morphs from dark navy at the top to warm cream at the bottom based on scroll.
export default function RimacTransition() {
  const ref = React.useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "-15%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.3, 0.7, 1], [0.3, 1, 1, 0.3]);

  return (
    <section
      ref={ref}
      className="relative w-full h-[80vh] min-h-[560px] overflow-hidden bg-[#0B1623]"
      data-testid="rimac-transition"
      aria-label="Proceso"
    >
      {/* Background mockup image */}
      <motion.div style={{ y }} className="absolute inset-0">
        <img
          src="/mockups/v2_02_rimac_transition_stripe.jpg"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        {/* subtle mix over the image */}
        <div className="absolute inset-0 bg-[#0B1623]/20" />
      </motion.div>

      {/* Center title */}
      <motion.div
        style={{ opacity }}
        className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6"
      >
        <span className="font-rajdhani font-medium text-white/60 text-xs md:text-sm tracking-[0.5em] uppercase mb-6">
          Proceso HEBEH
        </span>
        <h2 className="font-rajdhani font-semibold text-white tracking-tight leading-[0.95] text-5xl sm:text-6xl md:text-7xl lg:text-8xl">
          Cero adelantos.
          <br />
          <span className="text-white/90">Cero sorpresas.</span>
        </h2>
        <p className="font-manrope text-white/70 text-base md:text-lg mt-8 max-w-2xl">
          Del clic al volante. Todo digital, todo transparente,
          <br className="hidden md:block" />
          y el enganche se paga hasta que tienes el auto frente a ti.
        </p>
      </motion.div>

      {/* Bottom fade into next (cream) section */}
      <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-b from-transparent to-[#FFFFFF]" />
    </section>
  );
}
